"use client";
import * as React from "react";
const SvgEditOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m9.83 5.35.817.818-8.052 8.052h-.817v-.817L9.83 5.35ZM13.03 0a.89.89 0 0 0-.623.258l-1.626 1.626 3.333 3.333 1.626-1.626a.885.885 0 0 0 0-1.254L13.66.257A.873.873 0 0 0 13.03 0Zm-3.2 2.835L0 12.665v3.333h3.333l9.83-9.83L9.83 2.835Z" }));
export {
  SvgEditOutlined as default
};
